import { render, staticRenderFns } from "./VueComponentsCardPage.vue?vue&type=template&id=27b64352"
import script from "./VueComponentsCardPage.vue?vue&type=script&lang=js"
export * from "./VueComponentsCardPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports